export default __webpack_public_path__ + "static/media/05_photo.d20e0e51.jpg";